import React from 'react';
import T from 'prop-types';
import { useSelector } from 'react-redux';
import { pick } from 'lodash-es';

import CsvExportButton from '../../../../components/Buttons/CsvExportButton';
import api from '../api';
import { aiDashboardAssets } from '../configs/constants';
import { aiDashboardAppsSelector } from '../selectors';

const PERMITTED_FILTERS = ['granularity', 'change_type', 'app_uid', 'month_date'];

const EXPORTABLE_ASSETS = [
  aiDashboardAssets.marketOverview,
  aiDashboardAssets.timeSpentPenetration,
  aiDashboardAssets.timeSpentPenetrationIndex,
  aiDashboardAssets.usageTrends,
  aiDashboardAssets.usageTransitions,
  aiDashboardAssets.segmentConcentration,
  aiDashboardAssets.sectorsStats,
  aiDashboardAssets.aiAppTrends,
  aiDashboardAssets.segmentTransitions,
  aiDashboardAssets.aiAppImpact,
];

const ALL_TOP_APPS_ASSETS = [aiDashboardAssets.aiAppTrends, aiDashboardAssets.segmentTransitions];

const CHANGE_TYPE_ASSETS = [aiDashboardAssets.timeSpentPenetration, aiDashboardAssets.sectorsStats];

const TabExportButton = ({ isPublic = false }) => {
  const aiDashboard = useSelector((state) => state.aiDashboard);
  const apps = useSelector(aiDashboardAppsSelector);
  const topApps = apps.data?.top_apps || [];

  const assets = EXPORTABLE_ASSETS.map((assetName) => {
    const asset = aiDashboard[assetName];
    let filters = pick(asset.filters || {}, PERMITTED_FILTERS);
    filters = CHANGE_TYPE_ASSETS.includes(assetName)
      ? { ...filters, change_type: null, change_types: ['year_over_year', 'period_over_period'] }
      : filters;
    return {
      asset_name: assetName,
      filters: ALL_TOP_APPS_ASSETS.includes(assetName)
        ? {
            ...filters,
            app_uids: topApps.map(({ unified_ref_no }) => unified_ref_no),
            app_uid: null,
          }
        : filters,
    };
  });

  const pending = EXPORTABLE_ASSETS.some((assetName) => aiDashboard[assetName].settings.pending);

  const handleTooltipShow = (isVisible) => {
    if (isVisible && isPublic && window.heap) {
      window.heap.track('Gen AI App Insights Marketing Export', { event: 'hover' });
    }
  };

  return (
    <CsvExportButton
      url={api.buildExportUrl('export')}
      disabled={isPublic || pending}
      tooltipText={isPublic ? 'Available with full access' : 'Download data to CSV'}
      method="post"
      colorVariant="light"
      body={{ assets }}
      featureNameText="Gen AI App Insights Export"
      onVisibleChange={handleTooltipShow}
    />
  );
};

TabExportButton.propTypes = {
  isPublic: T.bool,
};

export default TabExportButton;
